import stores from 'cd-eft/models/Stores';
import { action, observable } from 'mobx';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';

const { designStore, waterwayDesignStore, terraceDesignStore } = stores.AppStore;
export class CrossSectionManagerVM {
  @observable props;

  constructor(props: any) {
    this.props = props;
  }

  @action.bound openCrossSectionToolbar() {
    designStore.hideCrossSectionToolbar = !designStore.hideCrossSectionToolbar
    if (designStore.hideCrossSectionToolbar) this.closeCrossSectionToolbar();
  }

  @action.bound closeCrossSectionToolbar() {
    designStore.hideCrossSectionToolbar = true;
    designStore.hideSingleCrossSection = true;
    designStore.hideThreeCrossSection = true;
  }

  @action.bound async singleCrossSectionSwitchHandler(mapView) {
    designStore.hideSingleCrossSection = !designStore.hideSingleCrossSection;
    if (!designStore.hideSingleCrossSection) {   
      designStore.snappingEnabled = false;
      this.props.updateSnapIcon();
      this.props.toggleSnapping();
      const structureLayers = mapView?.map.allLayers.filter((layer) => {
          return layer.id.includes("intersect_border");
      });
      designStore.structureLayerExists = false;
      if (designStore.onNewStructureTab && (structureLayers && structureLayers.length < 1) && !designStore.currentDesignElementJson) {
        await MessageCenter.addErrorFromCode('CS_5');
      } else if ((structureLayers && structureLayers.length < 1) && !designStore.currentDesignElementJson) {
        await MessageCenter.addErrorFromCode('CS_1');
      } else if (designStore.terraceGroupsLength > 0 
        || designStore.wdtGroupsLength > 0 
        || (waterwayDesignStore.uiState !== "ReachDesignCalculate" && waterwayDesignStore.uiState !== "ReachDesignSurface" && waterwayDesignStore.uiState !== "")
        || (terraceDesignStore.uiState && terraceDesignStore.uiState !== "ChannelDesignCalculate" && terraceDesignStore.uiState !== "ChannelDesignSurface")
      ) {
        await MessageCenter.addErrorFromCode('CS_3');
      } else {
        designStore.structureLayerExists = true;
      }
    }
  }
  @action.bound async threeCrossSectionSwitchHandler() {
    designStore.hideThreeCrossSection = !designStore.hideThreeCrossSection;
    if (designStore.hideThreeCrossSection === false && waterwayDesignStore.uiState !== "ReachDesignCalculate" && waterwayDesignStore.uiState !== "ReachDesignSurface") {
      await MessageCenter.addErrorFromCode('WDT_125');
    }
  }

  @action.bound switch3DMapHandler() {
    designStore.toggle3DMap = !designStore.toggle3DMap;
  }
}